import styled, { keyframes } from "styled-components";

export const ContainerButtons = styled.div`
	.btns-group {
		&.findstore {
			margin-top: 30px;
			padding: 0 10px 0 0;
		}

		.btn-stores {
			&.active {
				background-color: var(--primary-color) !important;
			}

			&:hover {
				background-color: var(--primary-color) !important;
			}
		}
	}
`;

export const Container = styled.div`
	position: relative;
	width: 100%;
	height: 500px;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 1;
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		object-fit: cover;
		filter: blur(2px) grayscale(100%);
	}

	button {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%);
		z-index: 2;
		background-color: var(--secundary-color);
		color: var(--white);
		border-color: transparent;
		outline: none;
		font-size: 1em;
		padding: 10px 30px;
		text-transform: uppercase;
	}
`;

export const PlacesList = styled.ul`
	list-style: none;
	padding-left: 0;
	max-height: 300px;
	width: 100%;
	padding-right: 30px;
	overflow-x: hidden;
	overflow-y: auto;

	li + li {
		margin-top: 15px;
	}

	li {
		cursor: pointer;
		background-color: transparent;
		transition: all 0.3s ease;
		padding: 5px;
		border-radius: 4px;

		&.active,
		&:hover {
			background-color: #ebebeb;
		}

		p {
			margin: 0;
			font-size: 14px;

			&:nth-of-type(1) {
				font-size: 18px;
				line-height: 24px;
				font-weight: bold;
				text-transform: uppercase;
			}
		}
	}
`;

const change = keyframes`
    0% {
        background-position: -468px 0;
    }
  
    100% {
        background-position: 468px 0; 
    }
`;

export const ShimmerEffect = styled.div`
	width: 100%;
	height: 500px;
	background: #f6f7f8;
	background-image: linear-gradient(
		to right,
		#f6f7f8 0%,
		#edeef1 20%,
		#f6f7f8 40%,
		#f6f7f8 100%
	);
	background-repeat: no-repeat;
	background-size: 800px 100%;
	display: inline-block;
	position: relative;
	animation: ${change} 1s ease-in-out infinite;
`;
